exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cf .claim-search-details .customer-link-item .data-key,.hitachi .claim-search-details .customer-link-item .data-key{color:#333}.claim-search-details .customer-link-item .data-key{color:#367c2b;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/claim/claim-search/components/claim-search-details.scss
// module id = 5029
// module chunks = 0